import { render, staticRenderFns } from "./TimerDot.vue?vue&type=template&id=076f0748&scoped=true&"
import script from "./TimerDot.vue?vue&type=script&lang=js&"
export * from "./TimerDot.vue?vue&type=script&lang=js&"
import style0 from "./TimerDot.vue?vue&type=style&index=0&id=076f0748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076f0748",
  null
  
)

export default component.exports